export default __webpack_public_path__ + "static/media/info-icon.67971a2e.svg";